import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    this._onDocumentClick = this._closeOnOutsideClick.bind(this);
    this._onKeydown = this._closeOnEscape.bind(this);
  }

  disconnect() {
    this._removeListeners();
  }

  stopRowNavigation(event) {
    event.stopPropagation();
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.menuTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "true");
    this._positionMenu();
    document.addEventListener("click", this._onDocumentClick);
    document.addEventListener("keydown", this._onKeydown);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "false");
    this._removeListeners();
  }

  edit(event) {
    event.preventDefault();
    event.stopPropagation();
    this.close();
    window.location.assign(event.currentTarget.href);
  }

  duplicate(event) {
    event.preventDefault();
    event.stopPropagation();
    this.close();
    this._submitForm(event.currentTarget.href, "POST");
  }

  archive(event) {
    event.preventDefault();
    event.stopPropagation();
    this.close();

    const message =
      event.currentTarget.dataset.scenarioTableActionsConfirmParam ||
      "Are you sure you want to archive this scenario?";
    if (!window.confirm(message)) return;

    this._submitForm(event.currentTarget.href, "PATCH");
  }

  _closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  _closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  _removeListeners() {
    document.removeEventListener("click", this._onDocumentClick);
    document.removeEventListener("keydown", this._onKeydown);
  }

  _positionMenu() {
    const rect = this.buttonTarget.getBoundingClientRect();
    const menu = this.menuTarget;

    menu.style.position = "fixed";
    menu.style.left = "auto";
    menu.style.right = `${window.innerWidth - rect.right}px`;
    menu.style.top = `${rect.bottom + 8}px`;
    menu.style.bottom = "auto";
  }

  _submitForm(url, method) {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = url;

    if (method !== "POST") {
      const methodInput = document.createElement("input");
      methodInput.type = "hidden";
      methodInput.name = "_method";
      methodInput.value = method;
      form.appendChild(methodInput);
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const tokenInput = document.createElement("input");
      tokenInput.type = "hidden";
      tokenInput.name = "authenticity_token";
      tokenInput.value = csrfToken;
      form.appendChild(tokenInput);
    }

    document.body.appendChild(form);
    form.submit();
  }
}
